/* eslint-disable */
"use strict";

var config, service, customers;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  customers = config.VUE_APP_MOL_S_CUSTOMERS
}

async function cicleSync(multiplo) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${customers}/cicleSync`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ multiplo }),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function getRunMode() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${customers}/mode`);
    const result = await response.json();
    if (result.status === 404) {
      return defaultRunMode();
    }
    return result;
  } catch {
    return defaultRunMode();
  }
}

function defaultRunMode() {
  return {
    modulo: "CLIENTI",
    locale: "---",
    remote: "---",
    versione: "---",
    health: "---",
  };
}

async function searchClienti(searchText) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${customers}/search?flt=${searchText}&cl=true`
  );
  return await response.json();
}

async function getClienti() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${customers}`); // TODO: da rivedere
  const cc = await response.json();
  const clienti = cc.total_rows > 0 ? cc.rows.map((x) => x.doc) : [];
  return clienti.filter((x) => x.amministrativi && x.amministrativi.cliente);
}

async function getFornitori() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${customers}/fornitori`); // TODO: da rivedere
  return await response.json();
}

async function searchFornitori(searchText) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${customers}/search?flt=${searchText}&fr=true`
  );
  return await response.json();
}

async function getEmettitori() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${customers}/emettitori`);
  return await response.json();
}

async function getCliente(clienteId) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${customers}/${clienteId}`);
  return await response.json();
}

async function creaCliente(cliente) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${customers}/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(cliente),
  });
  return await response.json();
}

async function creaClientiMultipli(clienti) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    clienti,
  };
  const response = await fetch(`${service}/${customers}/multipli/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function getModello() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${customers}/modello`);
  return await response.json();
}

async function modificaCliente(cliente) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${customers}/${cliente._id}/update`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(cliente),
    }
  );
  return await response.json();
}

async function getCardFromBarcode(barcode) {
  if (!config || !service) {
    await getConfigFile();
  }
  console.log("clienti--> getCardFromBarcode");
  const response = await fetch(`${service}/${customers}/cards/${barcode}`);
  return await response.json();
}

async function getFilteredCustomers(filtri, opzioni, versione) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni,
  };
  try {
    const response = await fetch(
      `${service}/${customers}/${versione ? versione + "/" : ""}filter`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function getFilterByDescription(filtri, opzioni, versione) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni,
  };
  try {
    const response = await fetch(`${service}/${customers}/description/filter`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function cancellaCliente(cliente) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${customers}/${cliente._id}/delete`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function salvaDestinazione(codiceCliente, destinazione) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${customers}/${codiceCliente}/destinazione`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(destinazione),
      }
    );
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function eliminaDestinazione(codiceCliente, destinazione) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${customers}/${codiceCliente}/destinazione/delete`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(destinazione),
      }
    );
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function salvaContatto(codiceCliente, contatto) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${customers}/${codiceCliente}/contatto`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(contatto),
      }
    );
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function eliminaContatto(codiceCliente, contatto) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${customers}/${codiceCliente}/contatto/delete`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(contatto),
      }
    );
    return await response.json();
  } catch (error) {
    return null;
  }
}

const getClientiByIds = async function(ids) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${customers}/ids`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ids),
    });
    const result = await response.json();
    return result.rows.filter((x) => !x.value.deleted).map((x) => x.doc);
  } catch (error) {
    // winston.error(`getClientiByIds: ${error}`);
    return error;
  }
};

// deprecata
async function companyInformation(piva_cf_or_id) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      piva_cf_or_id,
    };
    const response = await fetch(`${service}/${customers}/company`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function companyV2Information(piva_cf_or_id, tipoAzienda) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      piva_cf_or_id,
      tipoAzienda
    }
    const response = await fetch(`${service}/clienti/v2/company`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    return null
  }
}

// TODO: Su moleculer va fatto un servizio unico per tutti gli allegati (clienti, prodotti, documenti, etc) che poi utilizza Amazon S3 come repository (NON su server IBM)

async function aggiornaAllegati(idCliente, allegati) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${customers}/${idCliente}/allegati`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(allegati),
      }
    );
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function eliminaAllegato(codiceCliente, allegato) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${customers}/${codiceCliente}/allegati/delete`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(allegato),
      }
    );
    return await response.json();
  } catch (error) {
    return null;
  }
}

export default {
  cicleSync,
  getRunMode,
  searchClienti,
  getClienti,
  getFornitori,
  searchFornitori,
  getEmettitori,
  getCliente,
  creaCliente,
  creaClientiMultipli,
  getModello,
  modificaCliente,
  getCardFromBarcode,
  getFilteredCustomers,
  getFilterByDescription,
  cancellaCliente,
  salvaDestinazione,
  eliminaDestinazione,
  salvaContatto,
  eliminaContatto,
  getClientiByIds,
  companyInformation,
  companyV2Information,
  aggiornaAllegati,
  eliminaAllegato,
};
